import { Box } from "@mui/material";
import { ChatPdVContent } from "./ChatPdVContent";
import { contorno } from "../identidade";

interface ChatPdVSidebarProps {
    isDrawer?: boolean;
}

export const ChatPdVSidebar = ({ isDrawer = false }: ChatPdVSidebarProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: 350,
                height: isDrawer ? '100dvh' : 'calc(100vh - 50px)',
                minHeight: 0,
                borderLeft: theme => (isDrawer ? 'none' : contorno(theme, 0.09)),
                backgroundColor: 'background.paper',
                overflow: 'hidden',
            }}
        >
            <ChatPdVContent />
        </Box>
    );
};
